import { Capacitor } from '@capacitor/core'

import { fetchJson } from './util'

const REVENUECAT_API_URL = 'https://api.revenuecat.com/v1' as const

export const REVENUECAT_PUBLIC_API_KEYS = {
	ios: 'appl_XGvBjGRDDUeNObAXpYkBnbfgGpx',
	android: 'goog_PNrwTetoIiFXGXYaQTDFnwYVGyH',
	web: 'strp_rNdPEHfgbcrZldXWZHnSFZiTxZR',
} as const

export const getRevenueCatApiKey = () => {
	const platform = Capacitor.getPlatform()
	return REVENUECAT_PUBLIC_API_KEYS[platform as keyof typeof REVENUECAT_PUBLIC_API_KEYS]
}

export const fetchRevenueCatCustomerInfo = async (id: UserId): Promise<StoreCustomerInfo> => {
	const apiKey = getRevenueCatApiKey()
	if (!apiKey) {
		throw new Error(`No RevenueCat API key for platform ${Capacitor.getPlatform()}`)
	}

	const response = await fetchJson<RevenueCatAPIV1<RevenueCatCustomerInfoAPIV1>>(
		`${REVENUECAT_API_URL}/subscribers/${id}`,
		{
			method: 'GET',
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: `Bearer ${apiKey}`,
			},
		},
	)

	return response.subscriber
}
